'use client'

import { useSession } from '@marketplace-web/shared/session-data'
import { reloadPage } from '@marketplace-web/browser/browser-navigation-util'
import { confirmComplaintResolved } from '@marketplace-web/help-center-conversation-support/conversation-support-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

type Props = ConversationActionProps

const ConfirmComplaintResolved = ({ primary, title, inverse, theme, size }: Props) => {
  const { user } = useSession()

  const { conversation } = useConversationContext()
  const conversationId = conversation?.id

  async function markIssueResolved() {
    if (!user?.id || !conversationId) return

    await confirmComplaintResolved(conversationId)

    reloadPage()
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      onClick={markIssueResolved}
    />
  )
}

export default ConfirmComplaintResolved
